import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Format FastAPI validation errors into a human-friendly string
export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (typeof d === "object" && typeof d.msg === "string") return d.msg;
  if (typeof d === "object" && typeof d.message === "string") return d.message;
  return String(d);
}
